import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setConfigModalOpen,
        setConfigPage,
        get_email_config_list,
        create_email_config,
        update_email_config,
        setAction,
        setId,
        setStatus,
        setSearchQuery,
        activate_deactivate_email_config,
        get_email_config_details  
 } from "../../../store/smtp_config/smtpSlice";
const mapStateToProps = (state) => {
  const {
      is_email_config_modal_open,
      config_list,
      common_loading,
      total_email_config_count,
      active_email_config,
      page,
      c_action,
      config_id,
      selected_status,
      search_query,     
      selected_data
    } = state.email_config;
  return {
      is_email_config_modal_open : is_email_config_modal_open,
      config_list : config_list,
      total_email_config_count : total_email_config_count,
      common_loading : common_loading,
      active_email_config : active_email_config,
      page : page,
      c_action : c_action,
      config_id : config_id,
      selected_status : selected_status,
      search_query : search_query,
      selected_data : selected_data,
      
  };
  };
  
  const mapDispatchToProps = (dispatch) =>
      bindActionCreators({
      setConfigModalOpen,
      setConfigPage,
      get_email_config_list,
      create_email_config,
      update_email_config,
      setAction,
      setId,
      setStatus,
      setSearchQuery,
      activate_deactivate_email_config,
      get_email_config_details
      }, dispatch);
  
  const Store = (Container) =>
      connect(mapStateToProps, mapDispatchToProps)(Container);
  
export default Store;